<template>
	<v-container>
		<Snackbar v-if="errored" msg="Error from Server" />
		<Snackbar v-if="deleted" msg="Operation Successfull" />	
		<v-dialog v-model="create" width="75%">
			<v-card>
				<NewCategory ref="createDialog"/>
			</v-card>
		</v-dialog>
		<v-dialog v-model="edit" width="75%">
			<v-card>
				<EditCategory :editId="editId" ref="editDialog"/>
			</v-card>
		</v-dialog>		
		<v-card-title>
			Categories
			<v-spacer></v-spacer>
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
			></v-text-field>
			<v-btn
				color="success"
				class="ml-8"
				@click="create = !create"
			>
				New
				<v-icon class="ms-2">
					mdi-plus
				</v-icon>
			</v-btn>			
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="categories"
			:search="search"
			class="elevation-1"
		>
			<template v-slot:[`item.actions`]="{ item }">
				<v-tooltip left>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="primary"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="(editId = item._id) && (edit = !edit)"
						>
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span> Edit </span>
				</v-tooltip>                
				<v-tooltip right>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="error"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="confirmDelete() && deleteCategory(item)"
						>
							<v-icon>mdi-delete</v-icon>
						</v-btn>
					</template>
					<span> Delete </span>
				</v-tooltip>
			</template>			
		</v-data-table>
	</v-container>
</template>

<script>
import axios from '../../plugins/axios'
import Snackbar from '@/components/Snackbar.vue'
import NewCategory from '../Categories/New.vue'
import EditCategory from '../Categories/Edit.vue'

export default {
  name: 'Categories',
	components: {
		Snackbar,
		NewCategory,
		EditCategory
	},	
  data: () => ({
    loading: true,
    errored: false,
    deleted: false,
		create: false,
		edit: false,
		editId: null,
    categories: [],
		search: '',
		headers: [
			{ text: 'Title', value: 'name', width: '45%', align: 'start' },
			{ text: 'Section', value: 'section', width: '45%', align: 'start' },
			{ text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '10%' }
		]
  }),
	mounted() {
		this.getCategories();
	},
	methods: {
		getCategories(){
			axios
			.get(`/category/`)
			.then(res => {
				this.categories = res.data.data;
			})
			.catch(err => {
				console.error("axios err", err);
				this.errored = true;
			})
			.finally(() => this.loading = false);
		},

		confirmDelete(){
			return confirm("Are you sure you want to delete this category?");
		},

		deleteCategory(category) {
			axios
			.delete(`/category/`, {data: {_id: category._id}})
			.then(() => {
        this.deleted = true
				this.getCategories();
			})
			.catch(err => {
				console.error("error", err);
				this.errored = true;
			})
			.finally(() => {
				this.loading = false;
			});
		}
	},
	watch: {
		create: function(){
			if(!this.create){
				this.getCategories();
				this.$refs.createDialog.reset();
			}
		},

		edit: function(){
			if(!this.edit){
				this.getCategories();
				this.editId = null;
				this.$refs.editDialog.reset();
			}
		}
	}
}
</script>

<style>

</style>